import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { UrgencyBar } from './components/UrgencyBar';
import { Services } from './components/Services';
import { HowItWorks } from './components/HowItWorks';
import { WhyUs } from './components/WhyUs';
import { Inpatient } from './components/Inpatient';
import { MilitaryHelp } from './components/MilitaryHelp';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingContact } from './components/FloatingContact';
import { PromoBanner } from './components/PromoBanner';
export function App() {
  useEffect(() => {
    document.title = 'Сайт створено';
  }, []);
  return <div className="min-h-screen bg-white font-sans text-[#0A0A0A]" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <UrgencyBar data-id="element-4" />
        <Services data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <WhyUs data-id="element-7" />
        <Inpatient data-id="element-8" />
        <Testimonials data-id="element-9" />
        <FAQ data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
      <FloatingContact data-id="element-13" />
      <PromoBanner data-id="element-14" />
    </div>;
}